export default "__VITE_ASSET__ZSM4SkOQ__"